import React from 'react';
import { useSelector } from 'react-redux';

import { usePokerSundayMillionWidget } from '../../model';

import Details from './Details/Details';
import NoSatellites from './NoSatellites/NoSatellites';
import styles from './Satellites.scss';
import Tournaments from './Tournaments/Tournaments';

const Satellites: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const tournamentsCount = useSelector(widgetSelect.getTournamentsCount);
  const isLoading = useSelector(widgetSelect.isLoading);

  if (!tournamentsCount && !isLoading) return <NoSatellites />;

  return (
    <div className={styles.root}>
      <Details />
      <Tournaments />
    </div>
  );
};

export default Satellites;
